import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

const basePath = '/dealer/logo';

@Injectable({
  providedIn: 'root'
})

export class DealerLogoService {
  constructor(private http: HttpClient) { }

  // uploads a logo for the current dealer
  uploadDealerLogo(formData: FormData): Observable<{ "url" : string }> {
    return this.http.post<{ "url" : string }>(`${basePath}`, formData);
  }

}
